import { render, staticRenderFns } from "./FormSUSAR.vue?vue&type=template&id=2b1c0f8c&scoped=true&"
import script from "./FormSUSAR.vue?vue&type=script&lang=js&"
export * from "./FormSUSAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c0f8c",
  null
  
)

export default component.exports